/* Wave2Wear category showcase — arrow scrolling + GOI-style hover image cycling. */
(function () {
  /* ---- horizontal arrow navigation ---- */
  function initScroller(scroller) {
    var strip = scroller.querySelector('.w2w-showcase__strip');
    var prev = scroller.querySelector('.w2w-showcase__nav--prev');
    var next = scroller.querySelector('.w2w-showcase__nav--next');
    if (!strip) return;
    function step() {
      var c = strip.querySelector('.w2w-showcase__card');
      var gap = parseFloat(getComputedStyle(strip).gap) || 12;
      return c ? (c.offsetWidth + gap) * 2 : 420;
    }
    if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
    function update() {
      var s = strip.scrollLeft, max = strip.scrollWidth - strip.clientWidth;
      if (prev) prev.classList.toggle('is-hidden', s <= 2);
      if (next) next.classList.toggle('is-hidden', s >= max - 2 || max <= 0);
    }
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- hover image cycling with progress timer ---- */
  var DURATION = 1400; // ms each image is shown while hovering
  function initGallery(wrap) {
    var imgs = wrap.querySelectorAll('.w2w-showcase__img');
    if (imgs.length < 2) return;
    var bar = wrap.querySelector('.w2w-showcase__progressbar');
    var idx = 0, timer = null;

    function show(i) {
      imgs[idx].classList.remove('is-active');
      idx = (i + imgs.length) % imgs.length;
      imgs[idx].classList.add('is-active');
    }
    function runBar() {
      if (!bar) return;
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(0)';
      void bar.offsetWidth; // reflow so the reset applies before animating
      bar.style.transition = 'transform ' + DURATION + 'ms linear';
      bar.style.transform = 'scaleX(1)';
    }
    function cycle() {
      runBar();
      timer = setTimeout(function () { show(idx + 1); cycle(); }, DURATION);
    }
    function start() {
      wrap.classList.add('is-hovering');
      show(1);      // jump to the next image immediately, like GOI
      cycle();
    }
    function stop() {
      wrap.classList.remove('is-hovering');
      clearTimeout(timer); timer = null;
      if (bar) { bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; }
      show(0);      // back to the featured (white-bg) image
    }
    wrap.addEventListener('mouseenter', start);
    wrap.addEventListener('mouseleave', stop);
  }

  function boot() {
    document.querySelectorAll('.w2w-showcase__scroller').forEach(initScroller);
    document.querySelectorAll('.w2w-showcase__imgwrap[data-w2w-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
